"use strict";

var _interopRequireDefault = require("/root/workspace/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _auth = require("@/utils/auth");
var _default = exports.default = {
  name: 'SSOLogin',
  mounted() {
    (0, _auth.removeToken)();
    this.exchangeToken();
  },
  methods: {
    getRedirectPath() {
      return '/';
    },
    async exchangeToken() {
      try {
        var _data$data;
        const baseHost = _vue.default.prototype.$appStatic || process.env.VUE_APP_STATIC;
        const response = await _axios.default.get(`${baseHost}/sso/exchange_token`, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        if (data.message === 'success' && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.access_token) {
          await this.$store.dispatch('user/loginSuccess', data.data);
          await this.$store.dispatch('user/getInfo');
          (0, _elementUi.Message)({
            message: '登录成功',
            type: 'success',
            duration: 1000
          });
          window.location.replace(this.getRedirectPath());
        } else {
          _elementUi.Message.error(data.error || 'Token交换失败');
          await this.$router.replace({
            path: '/login'
          });
        }
      } catch (error) {
        var _error$response;
        if (_axios.default.isAxiosError && _axios.default.isAxiosError(error) && ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 400) {
          _elementUi.Message.error('SSO认证失效，请重新登录');
        } else {
          _elementUi.Message.error('登录失败，请重试');
        }
        await this.$router.replace({
          path: '/login'
        });
      }
    }
  }
};